// Design tokens for the platform self-service redesign.
//
// These values come straight from the designer's mock ("IDP Redesign") — a
// committed dark theme built on Geist + Geist Mono with an indigo accent. They
// are the single source of truth for colours/typography across the custom shell
// and the two redesigned pages, so tweak them here rather than inline.

export const ACCENT = '#7b74ff';
export const ACCENT_LIGHT = '#8f89ff';
export const ACCENT_SOFT = '#a49dff';

export const color = {
  // Surfaces (darkest → lightest)
  bg: '#0a0c10', // page background
  bgSidebar: '#0c0e13',
  surface: '#0f1217', // cards / sections
  surfaceInset: '#0b0d12', // inputs / inset panels
  surfaceRaised: '#12151b', // hovered rows / small chips
  surfaceChip: '#141821',
  terminal: '#08090d', // log / command blocks

  // Text
  text: '#e7eaef',
  textStrong: '#f2f4f7',
  textBright: '#eef0f4',
  textSecondary: '#c2c8d1',
  textMuted: '#aab1bb',
  textFaint: '#9aa2ad',
  textDim: '#7b828d',
  textDimmer: '#6b7280',
  textDimmest: '#5f6772',
  textPlaceholder: '#565d69',

  // Borders
  border: 'rgba(255,255,255,.08)',
  borderSoft: 'rgba(255,255,255,.06)',
  borderStrong: 'rgba(255,255,255,.12)',
  borderInput: 'rgba(255,255,255,.1)',
  track: '#1c212b',

  // Semantic
  accent: ACCENT,
  accentLight: ACCENT_LIGHT,
  accentSoft: ACCENT_SOFT,
  green: '#46b26a',
  greenBright: '#5fbf7a',
  amber: '#d9a441',
  blue: '#5aa2e0',
  red: '#e06c75',
} as const;

export const font = {
  sans: `'Geist', system-ui, -apple-system, sans-serif`,
  mono: `'Geist Mono', 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace`,
} as const;

// A translucent tint of the accent, used for active nav / toggle backgrounds.
// color-mix keeps it readable against the surface at any accent value.
export const accentTint = (pct: number) =>
  `color-mix(in oklab, ${ACCENT} ${pct}%, transparent)`;
